import { NavigateFunction } from "react-router-dom";
import { ENUM_USER_ROLE } from "../../../enums";
import { ROUTE_PATHS } from "../../../routes/paths";
import { LoginFormData } from "./config";
import { LoginResponseData } from "./types";

interface CookieHelpers {
  setCookie: (name: string, value: string, options?: any) => void;
  removeCookie: (name: string, options?: any) => void;
}

const COOKIE_KEYS = {
  EMAIL: "email",
  PASSWORD: "password",
} as const;

export function handlePostLoginNavigation(
  userData: LoginResponseData,
  navigate: NavigateFunction
): void {
  if (userData.role === ENUM_USER_ROLE.OPPORTUNITY_VENDOR) {
    navigate(ROUTE_PATHS.MY_PROFILE);
    return;
  }

  if (!userData.profileId) {
    if (userData.role === ENUM_USER_ROLE.AMBASSADOR) {
      navigate(ROUTE_PATHS.AUTH.SIGNUP_MORE_ABOUT_AMBASSADOR_COMPANY);
      return;
    }

    if (userData.role === ENUM_USER_ROLE.VENDOR) {
      navigate(ROUTE_PATHS.AUTH.SIGNUP_MORE_ABOUT_VENDOR_COMPANY);
      return;
    }
  }

  if (!userData.isVerified) {
    if (userData.role === ENUM_USER_ROLE.VENDOR) {
      navigate(ROUTE_PATHS.MY_PROFILE);
      return;
    }
    navigate(ROUTE_PATHS.SIGNUP_SUCCESS);
    return;
  }

  navigate(ROUTE_PATHS.PROJECT.LIST);
}

export function handleRememberMeCookies(
  rememberMe: boolean,
  formData: LoginFormData,
  { setCookie, removeCookie }: CookieHelpers
): void {
  if (rememberMe) {
    setCookie(COOKIE_KEYS.EMAIL, formData.email);
    setCookie(COOKIE_KEYS.PASSWORD, formData.password);
  } else {
    removeCookie(COOKIE_KEYS.EMAIL);
    removeCookie(COOKIE_KEYS.PASSWORD);
  }
}
